import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {ShoppingCartModule} from "./shopping_cart_module";
import createPersistedState from "vuex-persistedstate";
import * as Cookies from "js-cookie";

/*
  INSPIRATIONS :
    - architecture globale du store : https://dev.to/nosrednakram/vuex-shopping-cart-4hc0
    - utilisation persistente via cookie : https://github.com/robinvdvleuten/vuex-persistedstate
*/

export default new Vuex.Store({
   state: {
   },

   mutations: {
   },

   actions: {
   },

   modules: {
      store: ShoppingCartModule
   },

   plugins: [
      createPersistedState({
         storage: {
           getItem: (key) => Cookies.get(key),
           // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
           setItem: (key, value) =>
             Cookies.set(key, value, { expires: 2, secure: true }),
           removeItem: (key) => Cookies.remove(key),
         },
       }),      
   ]

})
